import { APIUrlConstants, AppConstants } from "../../../common/APIConstants";
import RestEndPoint from "../../../common/RestEndPoint";
export default class SystemPipeLineListsScreenAPI {
  static getEntityTypes(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetEntityTypes,
      "GET",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static UpdateDigMasterPipeline(pipeLineId) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.UpdateDigMasterPipeline.replace("{pipeLineId}", pipeLineId),
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      {}
    );
  }

  static getEntityList(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.Getpipeline,
      "GET",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
  static getSystemList(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetSystemData,
      "GET",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static updateEntity(listId, data) {
    /*return RestEndPoint.callAzureFunction(
      APIUrlConstants.UpdateEntity.replace("{listId}", listId),
      "PUT",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
    */
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.UpdateDigMasterPipeline.replace("{listId}", listId),
      "PUT",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static updateSystem(listId, data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.UpdateDigMasterSystem.replace("{listId}", listId),
      "PUT",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static addSystemPipeLine(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.CreateSystemPipeLineData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }

  static addSystem(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.CreateSystemData,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }



  static getSystemData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetSystemData,
      "GET",
      AppConstants.APP_BACKEND_HOST_KEY,
      
    );
  }

  
}
